<style scoped lang="scss">
.shop-info-content-div {
    height: 100vh;
    background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 60%, #f8fafc 100%);
    padding: 1.5rem;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        width: 0;
        height: 0;
        display: none;
    }
}

.info-card {
    background: #ffffff;
    border-radius: 1.2rem;
    border: 1px solid rgba(226, 232, 240, 0.9);
    box-shadow: 0 12px 32px -20px rgba(15, 23, 42, 0.2);
    padding: 2rem;
    max-width: 680px;
    margin: 0 auto;
}

.card-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 2rem;
    padding-bottom: 1.25rem;
    border-bottom: 1px solid #f1f5f9;

    .header-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        height: 42px;
        border-radius: 0.75rem;
        background: linear-gradient(135deg, #2563eb, #3b82f6);
        color: #fff;

        svg {
            width: 22px;
            height: 22px;
        }
    }

    .header-text {
        h2 {
            font-size: 1.3rem;
            font-weight: 700;
            color: #0f172a;
            margin: 0;
        }

        p {
            font-size: 0.82rem;
            color: #94a3b8;
            margin: 0.15rem 0 0;
        }
    }
}

/* 信息展示卡片 */
.info-box {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 1.2rem;
    border-radius: 0.8rem;
    margin-bottom: 1rem;

    .box-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 0.6rem;
        flex-shrink: 0;
    }

    .box-content {
        flex: 1;
        min-width: 0;
    }

    .box-label {
        font-size: 0.75rem;
        color: #94a3b8;
        font-weight: 500;
        margin-bottom: 0.15rem;
    }

    .box-value {
        font-size: 0.9rem;
        color: #1e293b;
        word-break: break-all;
    }

    .box-action {
        flex-shrink: 0;
    }
}

.info-box.key-box {
    background: #eff6ff;
    border: 1px solid #bfdbfe;

    .box-icon {
        background: #dbeafe;
        color: #2563eb;
    }

    .box-value {
        font-family: monospace;
        color: #1e40af;
    }
}

.info-box.url-box {
    background: #f0fdf4;
    border: 1px solid #bbf7d0;

    .box-icon {
        background: #dcfce7;
        color: #16a34a;
    }

    .box-value {
        font-family: monospace;
        color: #15803d;
        font-size: 0.82rem;
    }
}

.info-box.balance-box {
    background: linear-gradient(135deg, #fef3c7, #fde68a);
    border: 1px solid #fcd34d;

    .box-icon {
        background: #fde68a;
        color: #d97706;
    }

    .box-value {
        font-size: 1.3rem;
        font-weight: 700;
        color: #b45309;
    }
}

/* 表单区域 */
.form-section {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid #f1f5f9;
}

/* 支付方式备注 */
.pay-mode-notice {
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    padding: 0.9rem 1rem;
    border-radius: 0.7rem;
    margin-bottom: 1rem;
    margin-top: 0.5rem;

    .notice-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 0.5rem;
        flex-shrink: 0;

        &.warning {
            background: #fef3c7;
            color: #d97706;
        }

        &.info {
            background: #dbeafe;
            color: #2563eb;
        }
    }

    p {
        margin: 0;
        font-size: 0.82rem;
        line-height: 1.6;
        color: #475569;

        strong {
            font-weight: 600;
        }
    }

    &.warning {
        background: #fffbeb;
        border: 1px solid #fde68a;

        p strong {
            color: #b45309;
        }
    }

    &.info {
        background: #eff6ff;
        border: 1px solid #bfdbfe;

        p strong {
            color: #1e40af;
        }
    }
}

.form-section-title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 1.25rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;

    &::before {
        content: '';
        width: 3px;
        height: 14px;
        background: #2563eb;
        border-radius: 2px;
    }
}

:deep(.el-form-item__label) {
    font-weight: 500;
    color: #475569;
}

:deep(.el-input__wrapper) {
    border-radius: 0.6rem;
}

.save-btn {
    width: 100%;
    height: 44px;
    font-size: 0.95rem;
    border-radius: 0.6rem;
    background: linear-gradient(135deg, #2563eb, #3b82f6);
    border: none;
}

@media screen and (max-width: 768px) {
    .shop-info-content-div {
        padding: 1rem;
    }

    .info-card {
        padding: 1.2rem;
        border-radius: 1rem;
    }

    .card-header {
        .header-icon {
            width: 36px;
            height: 36px;
        }

        .header-text h2 {
            font-size: 1.1rem;
        }
    }

    .info-box {
        padding: 0.75rem 0.9rem;
        flex-wrap: wrap;
    }
}
</style>

<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <UserHeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;height: 100vh;overflow: hidden;padding-left: 0;background-color: transparent;">
                    <div class="shop-info-content-div">
                        <div class="info-card">
                            <!-- 标题 -->
                            <div class="card-header">
                                <div class="header-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M3 9L12 2L21 9V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V9Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M9 21V12H15V21" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="header-text">
                                    <h2>小店信息</h2>
                                    <p>管理您的小店基本信息与配置</p>
                                </div>
                            </div>

                            <!-- 小店URL -->
                            <div class="info-box url-box" v-if="shopInfo.tenant_key">
                                <div class="box-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        style="width:18px;height:18px">
                                        <path
                                            d="M10 13C9.4 13 9 13.4 9 14C9 15.3 8.3 16 7 16C5.7 16 5 15.3 5 14C5 13.4 4.6 13 4 13C3.4 13 3 13.4 3 14C3 16.4 4.6 18 7 18C9.4 18 11 16.4 11 14C11 13.4 10.6 13 10 13Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M14 11C14.6 11 15 10.6 15 10C15 8.7 15.7 8 17 8C18.3 8 19 8.7 19 10C19 10.6 19.4 11 20 11C20.6 11 21 10.6 21 10C21 7.6 19.4 6 17 6C14.6 6 13 7.6 13 10C13 10.6 13.4 11 14 11Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="box-content">
                                    <div class="box-label">小店访问地址</div>
                                    <div class="box-value">{{ shopUrl }}</div>
                                </div>
                                <div class="box-action">
                                    <el-button size="small" type="success" plain
                                        @click="copyText(shopUrl)">复制</el-button>
                                    <el-button size="small" type="primary" plain @click="openShop">打开</el-button>
                                </div>
                            </div>

                            <!-- 余额 -->
                            <div class="info-box balance-box">
                                <div class="box-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        style="width:18px;height:18px">
                                        <path
                                            d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="box-content">
                                    <div class="box-label">账户余额</div>
                                    <div class="box-value">￥{{ shopInfo.balance || '0.00' }}</div>
                                </div>
                            </div>

                            <!-- 支付方式备注 -->
                            <div class="pay-mode-notice" v-if="shopInfo.order_pay_mode === 'tenant'">
                                <div class="notice-icon warning">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        style="width:18px;height:18px">
                                        <path
                                            d="M12 9V13M12 17H12.01M5.07 19H18.93C20.47 19 21.44 17.33 20.66 16L13.73 4C12.96 2.67 11.04 2.67 10.27 4L3.34 16C2.56 17.33 3.53 19 5.07 19Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <p>当前小店为<strong>自定义支付通道</strong>，游客访问小店后，将使用您自定义的支付通道进行支付，请确保余额充足，否则即使支付成功，余额支付开通授权时也会失败。
                                </p>
                            </div>
                            <div class="pay-mode-notice" v-else-if="shopInfo.order_pay_mode === 'system'">
                                <div class="notice-icon info">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                        style="width:18px;height:18px">
                                        <path
                                            d="M12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16ZM12 8V12M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <p>当前小店为<strong>系统支付通道</strong>，游客访问小店后，将使用系统支付通道进行支付，您自定义的支付通道不会生效，游客支付授权成功后，将发放反利给您。
                                </p>
                            </div>

                            <!-- 表单 -->
                            <div class="form-section">
                                <div class="form-section-title">基本设置</div>
                                <el-form :model="shopInfo" label-width="90px" label-position="right">
                                    <el-form-item label="小店名称">
                                        <el-input v-model="shopInfo.shop_name" placeholder="请输入小店名称" />
                                    </el-form-item>
                                    <el-form-item label="小店状态">
                                        <el-switch v-model="shopInfo.shop_status" :active-value="1" :inactive-value="0"
                                            active-text="营业中" inactive-text="已关闭" />
                                    </el-form-item>
                                    <el-form-item label="小店简介">
                                        <el-input v-model="shopInfo.shop_desc" type="textarea" :rows="3"
                                            placeholder="请输入小店简介" />
                                    </el-form-item>
                                    <el-form-item label="联系方式">
                                        <el-input v-model="shopInfo.contact" placeholder="请输入联系方式（如QQ、微信、邮箱等）" />
                                    </el-form-item>
                                    <el-form-item label="支付模式" v-if="isAdmin">
                                        <el-radio-group v-model="shopInfo.order_pay_mode">
                                            <el-radio value="tenant">自定义支付通道</el-radio>
                                            <el-radio value="system">系统支付通道</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" class="save-btn" @click="saveShopInfo"
                                            :loading="saving">
                                            保存修改
                                        </el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const shopInfo = ref({
    id: 0,
    tenant_key: '',
    shop_name: '',
    shop_status: 1,
    shop_desc: '',
    contact: '',
    balance: 0,
    order_pay_mode: '',
})
const saving = ref(false)
const isAdmin = ref(false)

const shopUrl = computed(() => {
    if (!shopInfo.value.tenant_key) return ''
    const origin = window.location.origin
    return `${origin}/shop?tenant_key=${shopInfo.value.tenant_key}`
})

const getShopInfo = async () => {
    try {
        const res = await axios.post(baseURL + '/api/shop/tenant/info', {}, { headers })
        if (res.data.code === 0) {
            shopInfo.value = { ...shopInfo.value, ...res.data.data }
            isAdmin.value = !!res.data.data.is_admin
        } else {
            ElMessage.error(res.data.msg || '获取小店信息失败')
        }
    } catch (e: any) {
        ElMessage.error('获取小店信息失败：' + e.message)
    }
}

const saveShopInfo = async () => {
    saving.value = true
    try {
        const res = await axios.post(baseURL + '/api/shop/tenant/update', {
            shop_name: shopInfo.value.shop_name,
            shop_status: shopInfo.value.shop_status,
            shop_desc: shopInfo.value.shop_desc,
            contact: shopInfo.value.contact,
            ...(isAdmin.value ? { order_pay_mode: shopInfo.value.order_pay_mode } : {}),
        }, { headers })
        if (res.data.code === 0) {
            ElMessage.success('保存成功')
        } else {
            ElMessage.error(res.data.msg || '保存失败')
        }
    } catch (e: any) {
        ElMessage.error('保存失败：' + e.message)
    } finally {
        saving.value = false
    }
}

const copyText = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
        ElMessage.success('已复制到剪贴板')
    }).catch(() => {
        ElMessage.warning('复制失败，请手动复制')
    })
}

const openShop = () => {
    window.open(shopUrl.value, '_blank')
}

onMounted(() => {
    getShopInfo()
})
</script>
